module.exports = __webpack_public_path__ + "static/converse-com-nossos-especialistas-9ab17b0d442c639ba8ef7461e838256a.png";